import { MarketView, OpportunityMarketView } from '@api-proxies';
import { MarketService } from '@http/clients/market.service';
import { MarketEntity } from './abstract/market-entity';

export class OpportunityMarketEntity extends MarketEntity<OpportunityMarketView> {
    constructor(marketService: MarketService) {
        super(marketService);
    }

    toDestination(entity: MarketView): OpportunityMarketView {
        return { marketId: entity.id, marketName: entity.name, id: 0 };
    }

    toSource(entity: OpportunityMarketView): MarketView {
        return { id: entity.marketId, name: entity.marketName };
    }
}
